import { defineStore } from 'pinia';

type Setting = { list: string; key: string; value: unknown };

export const useListSettingsStore = defineStore('listsettings', {
	state: () => ({
		settings: [] as Setting[],
	}),

	persist: {
		paths: ['settings'],
	},

	getters: {
		get() {
			return ({ list, key, def }: { list: string; key: string; def: unknown }): unknown => {
				let row = this.settings.find((e: Setting) => e.list === list && e.key === key);
				return row ? row.value : def;
			};
		},
	},

	actions: {
		set({ list, key, value }: { list: string; key: string; value: unknown }) {
			let row = this.settings.find((e) => e.list === list && e.key === key);
			if (row) {
				row.value = value;
			} else {
				this.settings.push({
					list,
					key,
					value,
				});
			}
		},
		reset() {
			this.settings = [];
		},
	},
});
